import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function getAfterSalesExtraList(data) {
    // Asumiendo que el endpoint será /v1/after-sales-extras
    let response = await getAPIResponse("/v1/after-sales-extras", data);
    return response;
}
